import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import LoginScreen from './components/auth/LoginScreen';
import Layout from './components/layout/Layout';
import Dashboard from './components/dashboard/Dashboard';
import MoodTracking from './components/mood/MoodTracking';
import PomodoroTimer from './components/focus/PomodoroTimer'; // Fixed import path
import Insights from './components/insights/Insights';
import Resources from './components/resources/Resources';
import Settings from './components/settings/Settings';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="mood" element={<MoodTracking />} />
            <Route path="focus" element={<PomodoroTimer />} />
            <Route path="insights" element={<Insights />} />
            <Route path="resources" element={<Resources />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;